export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.988 1.891c.372-.89 1.652-.89 2.024 0l.034.092 2.15 6.617h6.958c1.065 0 1.508 1.364.647 1.99l-5.63 4.09 2.15 6.618c.33 1.013-.83 1.855-1.692 1.23l-5.63-4.09-5.628 4.09c-.862.625-2.021-.217-1.692-1.23l2.149-6.618-5.629-4.09C.338 9.965.781 8.6 1.846 8.6h6.958l2.15-6.617.034-.092zm-.484 7.95a1.1 1.1 0 01-1.046.76H4.616l3.917 2.845a1.1 1.1 0 01.4 1.23l-1.498 4.605 3.918-2.846.15-.091a1.1 1.1 0 01.993 0l.15.091 3.917 2.846-1.496-4.604c-.147-.454.014-.95.4-1.23l3.917-2.847h-4.842a1.1 1.1 0 01-1.046-.76L12 5.235l-1.496 4.607z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};